import { Heart, Landmark, CalendarCheck } from "lucide-react";
import { BankDetails } from "@/components/donate/BankDonate";
import { PERKS } from "@/lib/perks";
import { VipPreviewButton } from "@/components/donate/VipPreview";

const HOW = [
  [Landmark, "Betrag wählen & überweisen", "Frei wählbar, einmalig oder regelmäßig – per Banküberweisung mit deinem persönlichen Code als Verwendungszweck."],
  [CalendarCheck, "Wir schalten dich frei", "Sobald die Zahlung da ist, aktivieren wir deinen Unterstützer-Account mit Laufzeit."],
  [Heart, "Willkommen im Unterstützer-Club", "Pinker Haken, leuchtendes Herz-Profil und Unterstützer-Geschenke – sofort für dich sichtbar."],
];

export function SupportBank() {
  return (
    <div id="vip-konto" className="relative overflow-hidden rounded-3xl p-5 sm:p-6 vip-card space-y-2 scroll-mt-40 lg:scroll-mt-28" data-testid="support-bank">
      <h2 className="font-display text-xl font-extrabold flex items-center gap-2"><Heart className="w-5 h-5 text-rose-500" fill="currentColor" /> Per Banküberweisung unterstützen</h2>
      <p className="text-sm text-slate-600">Überweise einen frei wählbaren Betrag. Gib im Verwendungszweck deinen <b>persönlichen Code</b> an – so ordnen wir deine Überweisung eindeutig zu, schalten deinen Unterstützer-Account frei und du bekommst eine Nachricht in der App.</p>
      <BankDetails />
    </div>
  );
}

export function SupportSteps() {
  return (
    <section className="space-y-3" data-testid="support-steps">
      <h2 className="font-display text-2xl font-extrabold">So wirst du Projekt Unterstützer</h2>
      <ol className="grid sm:grid-cols-3 gap-3">
        {HOW.map(([Icon, t, x], i) => (
          <li key={t} className="vip-card rounded-2xl p-4" data-testid={`support-step-${i}`}>
            <span className="flex items-center gap-2"><span className="w-9 h-9 rounded-xl vip-gold-metal flex items-center justify-center"><Icon className="w-5 h-5" /></span><span className="text-xs font-extrabold text-rose-600">0{i + 1}</span></span>
            <p className="mt-3 font-bold">{t}</p>
            <p className="text-sm text-slate-600 mt-1">{x}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}

export function SupportPerks() {
  return (
    <section className="relative overflow-hidden rounded-[2rem] vip-lux p-6 sm:p-8 border border-[#fda4af]/40 space-y-5" data-testid="support-perks">
      <span className="vip-lux-pattern" aria-hidden />
      <div className="relative">
        <p className="text-xs font-extrabold tracking-[0.3em] uppercase text-[#fecdd3]">Dein Dankeschön</p>
        <h2 className="font-display text-2xl font-extrabold mt-1 vip-gold-title">Das bekommst du als Projekt Unterstützer</h2>
        <p className="text-sm text-[#ffe4e6] mt-1">Als Dank für deine Unterstützung wird dein Konto zum Premium-Account:</p>
      </div>
      <ul className="relative grid sm:grid-cols-2 gap-3">
        {PERKS.map(([Icon, t, x], i) => (
          <li key={t} className="rounded-2xl p-4 bg-white/[0.08] border border-[#fda4af]/30 flex gap-3 fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`support-perk-${i}`}>
            <span className="w-10 h-10 shrink-0 rounded-xl vip-gold-metal flex items-center justify-center"><Icon className="w-5 h-5" /></span>
            <span><span className="block font-bold text-[#fff1f2]">{t}</span><span className="block text-sm text-[#fecdd3] mt-0.5">{x}</span></span>
          </li>
        ))}
      </ul>
      <VipPreviewButton className="relative w-full" testId="support-vip-preview" />
    </section>
  );
}

export function SupportClip() {
  return (
    <section className="relative overflow-hidden rounded-[2rem] vip-lux p-4 sm:p-6 border border-[#fda4af]/40 space-y-4 fade-up" data-testid="support-clip">
      <span className="vip-lux-pattern" aria-hidden />
      <div className="relative">
        <p className="text-xs font-extrabold uppercase tracking-[0.3em] text-[#fecdd3]">Im Video</p>
        <h2 className="font-display text-xl sm:text-2xl font-extrabold vip-gold-title mt-1">Alle Vorteile in 60 Sekunden</h2>
      </div>
      <video src="/itzcouple-unterstuetzer-clip-hochformat.mp4?v=3" poster="/itzcouple-unterstuetzer-clip-hochformat.jpg?v=3" controls preload="none" playsInline
        className="sm:hidden relative w-full max-w-[320px] mx-auto aspect-[9/16] rounded-2xl bg-[#4c0519] ring-1 ring-[#fda4af]/40" data-testid="support-clip-portrait" />
      <video src="/itzcouple-unterstuetzer-clip.mp4?v=3" poster="/itzcouple-unterstuetzer-clip.jpg?v=3" controls preload="none" playsInline
        className="hidden sm:block relative w-full aspect-video rounded-2xl bg-[#4c0519] ring-1 ring-[#fda4af]/40" data-testid="support-clip-landscape" />
    </section>
  );
}
